import React from 'react';
import { notification } from 'antd';
import { useAppSelector } from '../../store';

// 配置全局通知
notification.config({
  placement: 'topRight',
  duration: 4.5,
  maxCount: 3,
});

const NotificationCenter: React.FC = () => {
  const { notifications } = useAppSelector(state => state.ui);

  React.useEffect(() => {
    // 监听新通知
    if (notifications && notifications.length > 0) {
      const latestNotification = notifications[0] as any;
      if (latestNotification && !latestNotification.read) {
        const { type, title, message } = latestNotification;

        // 类型安全的通知调用
        if (type && ['success', 'info', 'warning', 'error'].includes(type)) {
          (notification as any)[type]({
            message: title,
            description: message,
            key: latestNotification.id,
          });
        }
      }
    }
  }, [notifications]);

  return null;
};

export default NotificationCenter;
